// import { Component } from '@angular/core';
import { Component, OnInit, Inject } from "@angular/core";
import { Router } from "@angular/router";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { CryptographyService } from "../services/cryptography.service";

import { AddendumService } from "../services/addendum.service";

import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SuccessDialogComponent } from "../success-dialog/success-dialog.component";
import { AdminService } from "../services/admin.service";
import { Country } from "../models/country";
import { FailModuleComponent } from "../fail-module/fail-module.component";
import { AOWGroup } from "../models/aowgroup";
import { UserRoleEnum } from "../core/constant";


@Component({
  selector: "app-view-as-different-role",
  templateUrl: "./view-as-different-role.component.html",
  styleUrls: ["./view-as-different-role.component.scss"],
})
export class ViewAsDifferentRoleComponent {
  selectedCountryID: any;
  loading: boolean = false;
  countries: Country[] = [];
  selectedRole: string= "";
  role: number ;
  error: string = "";
  aowGroups: AOWGroup[] = [];
  selectedAOWgrp: number;

  constructor(
    private adminService: AdminService,
    private addendumService: AddendumService,
    private router: Router,
    @Inject(LOCAL_STORAGE)
    public storage: WebStorageService,
    private cryptographyService: CryptographyService,
    private ngbModal: NgbModal
  ) {}

  ngOnInit() {
    this.getMasterData();
    // this.getAllCountries();
  }

  selectRole(role: string) {
    if (role == "Market Admin") {
      this.selectedRole = role;
      this.role = UserRoleEnum.MarketAdmin;
    } else if (role == "AOW Admin") {
      this.selectedRole = role;

      this.role = UserRoleEnum.AOWAdmin;
    } else {
      this.selectedRole = role;
      this.role = UserRoleEnum.BasicUser;

    }
  }
  //
  viewAsRole() {
    this.loading = true;
    if (this.selectedRole === "Market Admin" && !this.selectedCountryID) {
      alert("Please select Country");
      this.loading = false;
      return;
    }

    if (
      this.selectedRole === "AOW Admin" &&
      (!this.selectedCountryID || !this.selectedAOWgrp)
    ) {
      alert("Please select both Country and AOW Group");
      this.loading = false;
      return;
    }

    // const payload = {
    //   Id: this.cryptographyService.decryptData(this.storage.get("userId")),
    //   UserRoleId: this.role,
    //   Email: this.cryptographyService.decryptData(this.storage.get("email")),
    //   countryId: this.selectedCountryID ? [this.selectedCountryID] : this.cryptographyService.decryptData(this.storage.get("countryId")),
    //   AOWGroupId: this.selectedRole == "AOW Admin" ? this.selectedAOWgrp : null,
      
    // };
        sessionStorage.setItem('impersonationView','true');
        sessionStorage.setItem("userRoleId",this.cryptographyService.encryptData(this.role))
        sessionStorage.setItem("selectedCountryID",JSON.stringify([this.selectedCountryID]))
        this.router.navigate(['/locations'])
          .then(() => window.location.reload());
  }

  selectCountry(event) {
    this.selectedCountryID = event.value;
  }
  selectAOW(event) {
    this.selectedAOWgrp = event.value;
    console.log("event", event);
  }

  getMasterData() {
    this.loading = true;
    this.adminService.getMasterDataForAddEditUser().subscribe((data: any) => {
      this.countries = data.countries
        ? data.countries.map((country) => new Country(country))
        : null;
      this.aowGroups = data.aowGroups
        ? data.aowGroups.map((aowGroup) => new AOWGroup(aowGroup))
        : null;
      this.loading = false;
      (error: string) => {
        this.loading = false;
      };
    });
  }
}
